export const getlistPayload = {
  properties: [
    "name",
    "salesorderid",
    "statecode",
    "totalamount",
    "requestdeliveryby",
    // "_ctpt_eventid_value",
    "_transactioncurrencyid_value"
  ],
  formattedFields: ["_ctpt_sonicwebformsubmission_value"],
  filter: {
    globalfilter: "",
    globalAndOperator: false,
    fieldAndOperator: false,
    filterfields: [
      {
        field: "_customerid_value",
        searchvalue: "",
        type: "guid",
      },
    ],
  },
  Aggregate: {
    AggregateFields: [
      {
        Field: "totalamount",
        Type: "sum",
        Alias: "Amount",
      },
    ],
  },
  recordtype: "salesorders",
  idfield: "salesorderid",
  continuationToken: "",
  pazesize: "10",
};
